// @flow
import * as React from 'react';
import { injectIntl } from 'react-intl';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

// Components
import { Container } from 'reactstrap';
import AppointmentFlowWizard from 'components/templates/AppointmentFlowWizard/';
import ErrorPanel from 'components/atoms/ErrorPanel';
import VehiclePanelWithGrayOut from 'components/atoms/VehiclePanelWithGrayOut';

import './ErrorPage.scss';

const ns = 'check-in-error';

export type Props = {
  intl: IntlShape,
  selfCheckInData: Object,
  vehicle: Object,
  startTime: Object,
  errorType: string
};

class ErrorPage extends React.Component<Props> {
  getErrorPage = () => {
    // ToDo: remove hardcoded data and default messages when localizations strings are ready and services are integrated
    const { vehicle, startTime, errorType } = this.props;
    return (
      <div>
        <ErrorPanel errorType={errorType} />
        {vehicle.make && (
          <React.Fragment>
            <h2 className={`${ns}__label`}>
              {this.props.intl.formatMessage({
                id: 'c8.self.check.in.error.page.your.appointment'
              })}
            </h2>
            <VehiclePanelWithGrayOut
              vehicleInfo={vehicle}
              startTime={startTime}
              addMask={true}
            />
          </React.Fragment>
        )}
      </div>
    );
  };

  render() {
    // ToDo: Remove default message when localization string is ready
    return (
      <AppointmentFlowWizard
        isSelfCheckIn={true}
        className={ns}
        header={() => {}}
        footer={() => {}}
        body={() => (
          <Container className={`${ns}__container`}>
            <h1 className={`${ns}__title my-3`}>
              {this.props.intl.formatMessage({
                id: 'c8.self.check.in.common.final.check.in',
                defaultMessage: 'Check in'
              })}
            </h1>
            {this.getErrorPage()}
          </Container>
        )}
      />
    );
  }
}

export default injectIntl(ErrorPage);



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ErrorPage/ErrorPage.js